<template>	
<div class="container">	
    <img  src="../../assets/survey.png" class="topimg"/> 
    <div class="ratingbox">     
        <van-row>
            <van-col span="24">
                <van-cell title="服务单号码：" :value="soNumber" />
            </van-col>           
        </van-row>
        <van-row>
            <van-col span="24">
                <van-cell title="报修机型：" :value="printerModel" />
            </van-col>           
        </van-row>        
        <van-row>
            <van-col span="24">
                <van-cell title="服务站：" :value="staName" />
            </van-col>           
        </van-row> 
        <van-row>
            <van-col span="24">
                <van-cell title="完成日期：" :value="fixedDate" />
            </van-col>           
        </van-row>   
        </div>  
        <div class="questionbox">   
        <van-divider contentPosition="left">您对本次维修服务总体满意度评价</van-divider>  
        <van-row>
            <van-col span="8">总体评价</van-col>
            <van-col span="16"><van-rate :value ="rating[0]" class="itemstar"/> </van-col>
        </van-row>       
        <van-row>
            <van-col span="8">服务态度</van-col>
            <van-col span="16"><van-rate :value ="rating[1]" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">服务便捷度</van-col>
            <van-col span="16"><van-rate  :value ="rating[2]" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">维修时长</van-col>
            <van-col span="16"><van-rate  :value ="rating[3]" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">服务态度</van-col>
            <van-col span="16"><van-rate  :value ="rating[4]" class="itemstar"/>  </van-col>
        </van-row> 
        <van-row>
            <van-col span="8">吐槽&表扬</van-col>
            <van-col span="16">
                <van-field 
                clearable
                :value = "comments" 
                type="textarea"            
                autosize
                />
            </van-col>
        </van-row>            
    </div>	  
</div>
</template>
<script>
import Vue from 'vue'
export default {
	  name: 'survey',	 
	  data(){
	  		return{		
	  		    headerimg: require('@/assets/survey.png'),
                rating:[0,0,0,0,0],
                comments:'',
                soNumber:'',
                printerModel:'',
                guarantee:'',
                staName:'',
                sn:'',
                fixedDate:'',
                access_token:'',
                idlink:''
	  		}  	 
		},
        created(){          
           let id = this.$route.query.id         
           this.idlink = id.substring(0,32)
           this.access_token = id.substring(32,64)
           console.log(id, this.idlink, this.access_token)
           this.getorderinfo(this.idlink)
        },
        mounted(){
		document.title = '维修满意度调研';  
	    },
        methods:{        
            getorderinfo(idlink){
                let that = this
                let url = 'https://t3.lenovoimage.com/api/pdsm/bizorderinfo';
                let myparams = {
                    id: idlink
                };
                let myheaders = {
                    'Authorization': this.access_token
                }
		        // START GET
                Vue.axios.get(
                    url,
                    {
                        headers: myheaders,
                        params: myparams
                    }
                )
                .then(function (response) {
                console.log("ddd", response.data)
                if (response.data.Data.length > 0)
                {                    
                    that.soNumber = response.data.Data[0]["OrdID"]; 	
                    that.printerModel = response.data.Data[0]["model"]; 	
                    that.guarantee = response.data.Data[0]["guarantee"]; 
                    that.fixedDate = response.data.Data[0]["fixedtime"].substring(0,10); 
                    that.staName = response.data.Data[0]["staFullName"]; 
                    that.sn = response.data.Data[0]["serilcode"]; 
                    that.rating[0] = response.data.Data[0]["overall"]; 
                    that.rating[1] = response.data.Data[0]["q1"]; 
                    that.rating[2] = response.data.Data[0]["q2"]; 
                    that.rating[3] = response.data.Data[0]["q3"]; 
                    that.rating[4] = response.data.Data[0]["q4"]; 
                    that.comments = response.data.Data[0]["comments"]; 
                }
                 })
                .catch(function (error) {
                console.log(error);
                }) 		
            }           
        }    
}
</script>
<style>
.pc {
    text-align: center;
}
.container {
    margin:0 auto;
    padding: 0 auto;
    height: 100vh;
    background-color: white;
}
.lable {
    width:100 rpx;
    text-align: left;
}
.topimg {
    width: 100%;
}
.itemstar {
    margin:10px;
}
.ratingbox{
    text-align: left;
    margin-left:10px;
    margin-right:10px;
    font-size: 14px;
}
.questionbox{
    text-align: left;
    margin-left:20px;
    margin-right:20px;
    font-size: 14px;
}
</style>
